<template>
    <div class="vc-checkout-user l-form l-form--stacked">
        <template v-if="customerIsGuest">
            <div class="vc-checkout-user__login" v-if="storeAllowCustomerLogin">
                Already have an account? <span @click="openLoginModal()" class="c-link">Log In!</span>
            </div>
            <base-control :constraints="constraints.name"
                          :triggerValidation="guestCustomerValidationTriggered"
                          @validated="onNameValidated"
                          class="vc-checkout-user__name"
                          :id="formFieldsIds.guestCustomerName"
                          key="checkout-user-name"
                          label="Name"
                          name="name"
                          rightIcon="user"
                          tabindex="1"
                          type="text"
                          v-model="name"></base-control>
            <checkout-customer-email></checkout-customer-email>
            <base-control class="vc-checkout-user__register"
                          :id="formFieldsIds.guestCustomerWantsToRegister"
                          key="checkout-user-register"
                          name="register"
                          tabindex="3"
                          type="checkbox"
                          v-if="storeAllowCustomerLogin"
                          v-model="wantsToRegister">Sign Up for an account to store purchases.
            </base-control>
        </template>
        <template v-else>
            <div :class="{'vc-checkout-user__logged--logging-out': loading.logout}"
                 @click="loading.logout ? $event.stopPropagation() : null"
                 class="vc-checkout-user__logged">
                <img :src="customer.avatar.files['100']" class="vc-checkout-user__logged__avatar">
                <div class="vc-checkout-user__logged__info">
                    <div class="vc-checkout-user__logged__info__username">Hi, {{ customer.name }}</div>
                    <div class="vc-checkout-user__logged__info__logout">Not you? <span @click="logout()" class="c-link">Sign Out</span>
                    </div>
                </div>
            </div>
        </template>
        <base-control
                      v-if="showLicenseTerms"
                      :constraints="constraints.licensesTermsAgreed"
                      :triggerValidation="licensesTermsValidationTriggered"
                      class="vc-checkout-user__register"
                      :id="formFieldsIds.licensesTerms"
                      key="checkout-user-agree"
                      name="agree"
                      tabindex="4"
                      type="checkbox"
                      v-model="licensesTermsAgreed">I agree to the <span @click.prevent="openLicenseModal()"
                                                                         class="c-link">license terms agreement(s).</span>
        </base-control>
        <base-alert type="success" v-show="guestCustomerTemporaryPasswordNotification">
            You'll be emailed a temporary password of your account once payment is made.
        </base-alert>
    </div>
</template>

<script>
import Login from '../../mixins/login.vue'
import CheckoutCustomerEmail from './checkout-customer-email.vue'
import {mapGetters} from 'vuex'

export default {
        name: "checkout-customer",
        components: {
            CheckoutCustomerEmail
        },
        mixins: [Login],
        data() {
            return {
                name: null,
                wantsToRegister: false,
                constraints: {
                    name: {
                        presence: {
                            allowEmpty: false,
                            message: 'Please enter your name.'
                        },
                    },
                    licensesTermsAgreed: {
                        presence: {
                            allowEmpty: false,
                            message: 'Please agree to the license terms agreement(s).'
                        },
                        inclusion: {
                            within: [true],
                            message: 'Please agree to the license terms agreement(s).'
                        }
                    }
                },
            }
        },
        computed: {
            ...mapGetters('checkout', [
                'storeAllowCustomerLogin',
                'customerAuthenticated',
                'customer',
                'customerIsGuest',
                'guestCustomerValidationTriggered',
                'licensesTermsValidationTriggered',
                'guestCustomerTemporaryPasswordNotification',
                'formFieldsIds',
                'showLicenseTerms'
            ]),
            licensesTermsAgreed: {
                get() {
                    return this.$store.getters['checkout/licensesTermsAgreed'];
                },
                set(value){
                    this.$store.commit('checkout/licensesTermsAgreed', value);
                }
            },
            cartItems(){
                return this.$store.state.cart.getCart()
            }
        },
        methods: {
            openLoginModal() {
                $("#loginModal").modal();
            },
            openLicenseModal() {
                $("#license-agreements").modal();
            },
            onNameValidated(validated) {
                this.$store.commit('checkout/guestCustomerNameValidated', validated);
            },
        },
        watch: {
            name(value) {
                this.$store.commit('checkout/guestCustomerName', value);
            },
            licensesTermsAgreed(value) {
                this.$store.commit('checkout/licensesTermsAgreed', value);
                this.$store.commit('checkout/licensesTermsValidationTriggered', false);
                this.$nextTick(()=> {
                    this.$store.commit('checkout/licensesTermsValidationTriggered', true);
                });
            },
            wantsToRegister(value) {
                this.$store.commit('checkout/guestCustomerWantsToRegister', value);
            }
        }

    }
</script>

<style lang="scss" scoped>
    $avatar-size: 41px;

    .vc-checkout-user {
        &__logged {
            display: grid;
            grid-template-columns: $avatar-size auto;
            grid-gap: 10px;
            align-items: center;

            &__info {
                font-weight: 600;

                &__username {
                    font-size: 14px;
                }

                &__logout {
                    font-size: 12px;
                }
            }

            &__avatar {
                width: $avatar-size;
                height: $avatar-size;
                border-radius: 5px;
            }

            &--logging-out {
                animation: pulse 800ms ease-in-out infinite;

                @keyframes pulse {
                    0% {
                        opacity: 1;
                    }
                    50% {
                        opacity: .4;
                    }
                    100% {
                        opacity: 1;
                    }

                }
            }
        }
    }
</style>
